import React, { useEffect, useState } from 'react'
import api from "../services/api";
import { getSession as getCachedSession, saveSession as saveSessionToDB } from "../services/db";

export function useSession(id: string | undefined) {
    const [session, setSession] = useState<{ data?: Resource.SessionResource; status: number } | null>();

    useEffect(() => {
        const fetchSession = async () => {
            if (!id) return;

            const url = `/provider/sessions/${id}`;

            if (navigator.onLine) {
                try {
                    const response = await api.get(url);
                    if (response.status === 200) {
                        setSession({ data: response.data, status: response.status });
                        await saveSessionToDB(id, response.data); // Salva no IndexedDB
                    } else {
                        const cached = await getCachedSession(id);
                        if (cached) {
                            setSession({ data: cached, status: 200 });
                        } else {
                            setSession({ status: response.status });
                        }
                    }
                } catch (error) {
                    const cached = await getCachedSession(id);
                    if (cached) {
                        setSession({ data: cached, status: 200 });
                    } else {
                        setSession({ status: 500 });
                    }
                }
            } else {
                const cached = await getCachedSession(id);
                if (cached) {
                    setSession({ data: cached, status: 200 });
                } else {
                    setSession({ status: 500 });
                }
            }
        };

        fetchSession();
    }, [id]);

    return session;
}
